import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.188 12.667a.667.667 0 0 0-.667.666V14a.667.667 0 1 0 1.333 0v-.667a.667.667 0 0 0-.666-.666M5.52 7.333A.667.667 0 0 0 4.854 8v.667a.667.667 0 0 0 1.334 0V8a.667.667 0 0 0-.667-.667m0 3.334a.667.667 0 0 0-.667.666V12a.667.667 0 1 0 1.334 0v-.667a.667.667 0 0 0-.667-.666m2.667-1.334A.667.667 0 0 0 7.52 10v.667a.667.667 0 1 0 1.333 0V10a.667.667 0 0 0-.666-.667m4.28-5.186a4.667 4.667 0 0 0-8.907 1.26A2.67 2.67 0 0 0 1.52 8a2.67 2.67 0 0 0 .893 2 .666.666 0 1 0 .88-1 1.33 1.33 0 0 1-.44-1 1.333 1.333 0 0 1 1.334-1.333A.667.667 0 0 0 4.854 6a3.333 3.333 0 0 1 6.487-1.073.67.67 0 0 0 .52.446 2 2 0 0 1 1.66 1.96c.01.491-.166.968-.493 1.334a.666.666 0 0 0 .986.893 3.334 3.334 0 0 0-1.546-5.387zm-1.614 3.186a.667.667 0 0 0-.666.667v.667a.667.667 0 1 0 1.333 0V8a.666.666 0 0 0-.667-.667m0 3.334a.667.667 0 0 0-.666.666V12a.667.667 0 1 0 1.333 0v-.667a.666.666 0 0 0-.667-.666M8.188 6a.667.667 0 0 0-.667.667v.666a.667.667 0 0 0 1.333 0v-.666A.667.667 0 0 0 8.188 6"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })